import { I18n } from '@calendly/i18n'
import { BodyText } from '@calendly/ui/components/typography'
import { colorTextSecondary } from '@calendly/ui/theme'

import { encodeAvailabilityRule } from 'components/availability/form/utils'
import { filterActiveRules } from 'components/availability/utils'
import { summarizeAvailabilityRule } from 'components/event_type_edit'

import { determineDateOverridesLabel, hasWeekdayIntervals } from './utils'

export const AvailabilitySummaryMessage = ({
  availableHours = [],
  timezone,
  timeNotation,
  dateOverrides = [],
  isPending = false,
  size = 'x-small',
  color = colorTextSecondary
}) => {
  const activeDateOverrides = filterActiveRules(dateOverrides)
  const hasDateOverrides = activeDateOverrides.length > 0
  const rule = encodeAvailabilityRule(availableHours, [], timezone)
  const typographyProps = { size, color }

  if (isPending) {
    return (
      <BodyText {...typographyProps}>
        {I18n.t('publisher.event_type_editor.sections.availability.multi_host.pending_availability_activation')}
      </BodyText>
    )
  }

  return (
    <>
      <BodyText {...typographyProps}>
        {summarizeAvailabilityRule(rule, timeNotation)}
      </BodyText>
      {hasDateOverrides && (
        <BodyText {...typographyProps}>
          {determineDateOverridesLabel(activeDateOverrides.length,
            hasWeekdayIntervals(encodeAvailabilityRule(availableHours, [], timezone)))}
        </BodyText>
      )}
    </>
  )
}
